import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import Listar from '../../../../../components/auth/saude/remume/listar'


function ListarRemumeSaudeScreen() {

    return (
        <Fragment>
            <Head titulo="Relação Municipal de Medicamentos Essenciais" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarRemumeSaudeScreen;